'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _redux = require('redux');
var _reactRedux = require('react-redux');
var _reduxPagan = require('redux-pagan');
var _ramda = require('ramda');
var _reduxConnect = require('redux-connect');

require('flag-icon-css/css/flag-icon.css');

var _ForeignPropertyPage = require('../../components/ForeignPropertyPage/ForeignPropertyPage');var _ForeignPropertyPage2 = _interopRequireDefault(_ForeignPropertyPage);

var _propertySearch = require('../../redux/modules/propertySearch');
var _propertyDetails = require('../../redux/modules/propertyDetails');
var _countries = require('../../redux/modules/countries');
var _foreignPropertySearch = require('../../redux/modules/foreignPropertySearch');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Styles
// Components
// Helpers
var ForeignPropertyPageWrapper = function (_Component) {_inherits(ForeignPropertyPageWrapper, _Component);function ForeignPropertyPageWrapper() {_classCallCheck(this, ForeignPropertyPageWrapper);return _possibleConstructorReturn(this, _Component.apply(this, arguments));}ForeignPropertyPageWrapper.prototype.componentDidMount = function componentDidMount() {if (this.props.isMobile) {
      this.props.suppressLoading(false);
    } else {
      var id = (0, _get2.default)(this.props, 'location.query.id');

      if (id) {var _id$split =
        id.split('_'),entityType = _id$split[0],propertyId = _id$split[1];
        this.props.openDetailsPopup({ entityType: entityType, propertyId: propertyId });
      }
    }
  };ForeignPropertyPageWrapper.prototype.

  render = function render() {
    return (
      _react2.default.createElement(_ForeignPropertyPage2.default, this.props));

  };return ForeignPropertyPageWrapper;}(_react.Component);


ForeignPropertyPageWrapper.displayName = 'ForeignPropertyPageWrapper';
ForeignPropertyPageWrapper.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool.isRequired,
  searchedAddress: _propTypes2.default.object,
  suppressLoading: _propTypes2.default.func,
  location: _propTypes2.default.object,
  openDetailsPopup: _propTypes2.default.func };


var mapStateToProps = function mapStateToProps(state) {return {
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile,
    langStatic: (0, _reduxPagan.getLang)(state.lang, 'static'),
    searchedAddress: (0, _get2.default)(state, 'foreignPropertySearch.searchedAddress'),
    favoriteIDs: state.favoriteProperties.favoriteIDs || [],
    countriesList: state.countries.data || [] };};


var mapDispatchToProps = function mapDispatchToProps(dispatch) {return (0, _redux.bindActionCreators)({
    suppressLoading: _propertySearch.suppressLoading,
    openDetailsPopup: _propertyDetails.openDetailsPopup,
    clearForeignSearchData: _foreignPropertySearch.clearForeignSearchData },

  dispatch);};

var asyncData = [{
  key: 'countries',
  promise: function promise(_ref) {var _ref$store = _ref.store,dispatch = _ref$store.dispatch,getState = _ref$store.getState;
    var promises = [];var _getState =
    getState(),countries = _getState.countries;
    var hasCountries = !countries.data || countries.data && !countries.data.length;
    var noCountries = hasCountries && !countries.loaded && !countries.loading;

    if (noCountries) {
      promises.push(dispatch((0, _countries.loadCountries)()));
    }

    return Promise.all(promises);
  } }];exports.default =


(0, _ramda.compose)(
(0, _reduxConnect.asyncConnect)(asyncData),
(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(
ForeignPropertyPageWrapper);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/ForeignPropertyPage/ForeignPropertyPage.js
// module id = 3085
// module chunks = 0